import { Box, Typography, useTheme } from '@mui/material';
import PoolsOverview from './card/PoolsOverview';
import { EvmTxHistory, PoolListType } from '@/types';
import { useEffect, useState } from 'react';
import { useWeb3 } from '@/hooks/use-web3';
import BigNumber from 'bignumber.js';
import { fiexdDecimal, packBigNumbers } from '@/lib/BigNumbers';
import { poolAmount } from '@/api/staking/read';

export default function Overview({
  contractAddr,
  txList,
  detail,
}: {
  contractAddr: string;
  txList: EvmTxHistory[] | null;
  detail: PoolListType | null;
}) {
  const [walletCnt, setWalletCnt] = useState('0');
  const [rate, setRate] = useState('0');
  const theme = useTheme();
  const { web3authCall } = useWeb3();
  useEffect(() => {
    (() => {
      if (!txList) {
        return '0';
      }
      const cnt = ownerCnt(txList);
      setWalletCnt(cnt);
    })();
    return () => {};
  }, [txList]);
  useEffect(() => {
    if (!detail) {
      return;
    }
    (async () => {
      if (!contractAddr) {
        return;
      }
      const data = await poolAmount(contractAddr);
      if (!data) {
        return;
      }
      const currentAmt = data.data;
      const re = fiexdDecimal(BigNumber(currentAmt).dividedBy(detail.goalUsdt).multipliedBy(100).toFixed(2));
      setRate(re);
    })();

    return () => {};
  }, [detail, contractAddr, web3authCall]);

  // 중복 제거한 지갑 개수
  const ownerCnt = (aData: EvmTxHistory[]): string => {
    if (!aData) {
      return '0';
    }
    const walletAddr = new Map<String, EvmTxHistory>();
    aData.forEach((item: EvmTxHistory) => {
      walletAddr.set(item.from, item);
    });
    const data = Array.from(walletAddr.values()) ?? '0';
    return String(data.length);
  };

  return (
    <Box
      sx={{
        padding: '16px 24px',
        maxWidth: '1680px',
      }}
    >
      <Typography variant="h3" color={theme.greyscale.darkgrey2} sx={{ marginBottom: '16px' }}>
        Overview
      </Typography>

      <Box
        sx={{
          display: 'flex',
          flexDirection: {
            xs: 'column',
            md: 'row',
          },
          gap: '10px',
        }}
      >
        {detail ? (
          <PoolsOverview title="Target Amount(Min)" content={`${packBigNumbers(detail.goalUsdt)} USD`} />
        ) : (
          <PoolsOverview title="Target Amount(Min)" content="0 USD" />
        )}
        <PoolsOverview title="Achievement Rate" content={`${rate}%`} />
        <PoolsOverview title="Number Of Wallets" content={walletCnt} />
      </Box>
    </Box>
  );
}
